import { render, staticRenderFns } from "./TakeAgain.vue?vue&type=template&id=bd015138&"
import script from "./TakeAgain.vue?vue&type=script&lang=js&"
export * from "./TakeAgain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TakeAgain.vue"
export default component.exports